import { useState } from 'react'
import { EnvelopeIcon, LockClosedIcon } from '@heroicons/react/24/outline'
import { Link, useNavigate } from 'react-router-dom'

import logo from '../../../logo-black-no-bg.svg'

import { BASE } from './_Layout'

// Preview login: same layout as the live provider login, but any submit drops
// you straight into the dashboard (no real auth in the mockup).
export default function ProviderLogin() {
    const navigate = useNavigate()
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')

    function handleSubmit(e: React.FormEvent) {
        e.preventDefault()
        navigate(`${BASE}/dashboard`)
    }

    return (
        <div className='flex flex-col items-center justify-center flex-1 min-h-screen px-4 py-12 bg-gradient-to-br from-brand-50 to-white'>
            <div className='w-full max-w-md'>
                <div className='flex flex-col items-center mb-8'>
                    <img src={logo} alt='BrightPath' className='h-16 mb-4' />
                    <h1 className='text-2xl font-bold text-neutral-900'>BrightPath for Providers</h1>
                    <p className='text-sm text-neutral-600 mt-1'>Sign in to your provider account</p>
                </div>

                <form
                    onSubmit={handleSubmit}
                    className='bg-white rounded-2xl shadow-sm border border-neutral-200 p-6 space-y-4'
                >
                    <div>
                        <label className='block text-sm font-medium text-neutral-700 mb-1.5'>Work email</label>
                        <div className='relative'>
                            <EnvelopeIcon className='absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-400' />
                            <input
                                type='email'
                                autoComplete='email'
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className='w-full pl-10 pr-3 py-2.5 border border-neutral-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent'
                            />
                        </div>
                    </div>

                    <div>
                        <label className='block text-sm font-medium text-neutral-700 mb-1.5'>Password</label>
                        <div className='relative'>
                            <LockClosedIcon className='absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-400' />
                            <input
                                type='password'
                                autoComplete='current-password'
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className='w-full pl-10 pr-3 py-2.5 border border-neutral-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent'
                            />
                        </div>
                    </div>

                    <button
                        type='submit'
                        className='w-full py-2.5 bg-brand-600 hover:bg-brand-700 text-white font-medium rounded-lg transition-colors'
                    >
                        Sign in
                    </button>

                    <div className='text-center'>
                        <Link to={`${BASE}/login`} className='text-sm text-brand-600 hover:underline'>
                            Forgot password?
                        </Link>
                    </div>
                </form>
            </div>
        </div>
    )
}
